import { render, staticRenderFns } from "./ClientesAduana.vue?vue&type=template&id=40c2fc9c&scoped=true&"
import script from "./ClientesAduana.vue?vue&type=script&lang=js&"
export * from "./ClientesAduana.vue?vue&type=script&lang=js&"
import style0 from "./ClientesAduana.vue?vue&type=style&index=0&id=40c2fc9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2fc9c",
  null
  
)

export default component.exports